import { BKJThemeColorType } from '@awais4123/fillify-design-library';
import { OrderStatusEnum } from 'types/graphql';

export type ShiftStatusCodeType = keyof typeof OrderStatusEnum;

export type ShiftPrettyStatusType =
  | 'Open'
  | 'Requested'
  | 'Accepted'
  | 'Assigned'
  | 'Cancelled'
  | 'Unfulfilled'
  | 'In Progress'
  | 'Completed'
  | 'Swapped'
  | 'Absent';

// design library change required
export const shiftStatusMap: Record<keyof typeof OrderStatusEnum | 'open', BKJThemeColorType> = {
  accepted: 'ShiftAccepted',
  assigned: 'ShiftAssigned',
  cancelled: 'ShiftCancelled',
  completed: 'ShiftCompleted',
  in_progress: 'ShiftInProgress',
  open: 'ShiftOpen',
  pending: 'ShiftPending',
  rejected: 'ShiftRejected',
  requested: 'ShiftRequested',
  unfulfilled: 'ShiftUnfulfilledStroke',
  swapped: 'ShiftSwapped',
  absent: 'ShiftAbsent',
};
